"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeHttpRequest = makeHttpRequest;
const https_1 = __importDefault(require("https"));
const errors_1 = require("./errors");
async function makeHttpRequest(method, url, body, timeout) {
    return new Promise((resolve, reject) => {
        const req = https_1.default.request(url, {
            method,
            rejectUnauthorized: false, // crucial for allowing self-signed certificates before subdomain is assigned
            headers: {
                'Content-Type': 'application/json'
            }
        }, (res) => {
            let data = '';
            res.on('data', (chunk) => data += chunk);
            res.on('end', () => {
                let responseBody;
                try {
                    responseBody = JSON.parse(data);
                }
                catch (_e) {
                    reject(new errors_1.Err(errors_1.ErrorCode.SERVER_ERROR, res.statusCode ?? 500, `Failed to parse JSON: ${data}`));
                    return;
                }
                if (res.statusCode && res.statusCode >= 200 && res.statusCode < 300) {
                    resolve(responseBody);
                }
                else {
                    reject(new errors_1.Err(responseBody.code ?? errors_1.ErrorCode.SERVER_ERROR, res.statusCode ?? 500, data));
                }
            });
        });
        if (timeout !== undefined) {
            req.setTimeout(timeout, () => {
                req.destroy();
                reject(new Error('Request timed out'));
            });
        }
        req.on('error', reject);
        req.write(JSON.stringify(body));
        req.end();
    });
}
//# sourceMappingURL=makeHttpRequest.js.map